import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "common-loading flexCenter dflex"
};
const _hoisted_2 = {
  class: "common-authing-body"
};

const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  class: "common-authing item7"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "dot dot1"
}), /*#__PURE__*/_createElementVNode("div", {
  class: "dot dot2"
}), /*#__PURE__*/_createElementVNode("div", {
  class: "dot dot3"
})], -1);

const _hoisted_4 = {
  class: "tc"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, _toDisplayString($props.text), 1)])]);
}